"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _node = require("./node");
Object.keys(_node).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _node[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _node[key];
    }
  });
});
var _jsxRuntime = require("react/jsx-runtime");
var _value = require("./value");
Object.keys(_value).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _value[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _value[key];
    }
  });
});
var _excluded = ["value", "style", "className"];
var JsonView = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var value = props.value,
    style = props.style,
    className = props.className,
    reset = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var defaultStyle = (0, _objectSpread2["default"])({
    lineHeight: 1.4,
    fontFamily: 'var(--w-rjv-font-family, Menlo, monospace)',
    color: 'var(--w-rjv-color, #002b36)',
    backgroundColor: 'var(--w-rjv-background-color, #00000000)'
  }, style);
  var cls = "w-json-view-container w-rjv ".concat(className || '');
  var keyid = (0, _react.useId)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_node.RooNode, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    className: cls,
    value: value
  }, reset), {}, {
    ref: ref,
    keyid: keyid,
    style: defaultStyle
  }));
});
var _default = JsonView;
exports["default"] = _default;